module.exports = __webpack_public_path__ + "img/5创建工作流.fdddae0e.gif";